import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import PageHeader from "@/components/PageHeader";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { LifeBuoy, Send } from "lucide-react";
import { toast } from "sonner";

/**
 * Support — شاشة الدعم الفني: أي مدرسة تقدر تبعت مشكلة تصل مباشرة
 * لصاحب المنصّة (super_admin)، ليتابعها ويحاول حلّها.
 */
export default function Support() {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!subject.trim() || !message.trim()) {
      toast.error("اكتب عنوان المشكلة ووصفها أولًا");
      return;
    }
    setSending(true);
    try {
      await api.post("/support-tickets", { subject, message });
      setSent(true);
      setSubject(""); setMessage("");
      toast.success("تم إرسال المشكلة بنجاح");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="support-page">
      <PageHeader
        icon={LifeBuoy}
        overline="النظام"
        title="الدعم الفني"
        subtitle="واجهت مشكلة أو لديك اقتراح؟ اكتبه هنا وسيصل مباشرة لفريق الدعم للمتابعة."
      />

      <div className="rounded-xl border border-border bg-white p-6 max-w-2xl space-y-4">
        <p className="text-sm text-muted-foreground">
          واجهت مشكلة في استخدام النظام؟ اكتبها هنا بالتفصيل وستصل مباشرة
          لفريق الدعم الفني للمتابعة والرد عليك في أقرب وقت.
        </p>

        {sent && (
          <div className="rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-800 text-sm px-4 py-3">
            ✅ تم استلام المشكلة بنجاح، وسيتم التواصل معك قريبًا.
          </div>
        )}

        <div className="space-y-1.5">
          <Label>عنوان المشكلة *</Label>
          <Input value={subject} onChange={(e) => setSubject(e.target.value)}
                 placeholder="مثال: لا أستطيع طباعة الشهادات" data-testid="support-subject" />
        </div>
        <div className="space-y-1.5">
          <Label>وصف المشكلة بالتفصيل *</Label>
          <Textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={6}
                    placeholder="اشرح المشكلة خطوة بخطوة، ومتى تحدث بالضبط..."
                    data-testid="support-message" />
        </div>
        <Button onClick={submit} disabled={sending} className="w-full h-11" data-testid="support-submit">
          <Send className="h-4 w-4 me-1.5" /> {sending ? "جارٍ الإرسال…" : "إرسال المشكلة"}
        </Button>
      </div>
    </div>
  );
}
